module.exports = __webpack_public_path__ + "img/question-shms.710030e2.png";